<template>
  <div class="bg-[#F7F8FB] flex flex-col sm:flex-row items-start sm:items-center rounded-md sm:rounded-full py-3 sm:py-2 text-md mb-4">
    <div
      class="bg-white h-8 sm:h-10 px-3 sm:px-4 ml-2.5 sm:mx-2 mb-2 sm:mb-0 inline-flex items-center rounded-full border font-bold"
      :class="classes"
    >
      <div class="mr-2">{{ title }}</div>
      <OIcon :icon="'check-circle'" />
    </div>
    <div class="font-normal ml-4 sm:ml-0">{{ desciption }}</div>
  </div>
</template>

<script>
import { defineComponent, useContext } from '@nuxtjs/composition-api';
import { OIcon } from '~/modules/common/components/ui';

export default defineComponent({
  components: { OIcon },
  props: {
    type: {
      type: String,
      validator: (value) => ['special', 'expert'].includes(value),
    },
  },
  setup(props) {
    const { i18n } = useContext();

    // color schema
    const colorSchema = {
      special: 'border-o-green text-o-green',
      expert: 'border-o-blue text-o-blue',
    };
    const classes = colorSchema[props.type];

    // title
    const titleList = {
      special: i18n.t('news-page.special-title'),
      expert: i18n.t('news-page.expert-title'),
    };
    const title = titleList[props.type];

    // desciption
    const desciptionList = {
      special: i18n.t('news-page.special-description'),
      expert: i18n.t('news-page.expert-description'),
    };
    const desciption = desciptionList[props.type];

    return { classes, title, desciption };
  },
});
</script>
